import { SAVE_YF_MANAGER_DATA, SAVE_YF_MANAGER_IMAGE } from './actionTypes'
import { YFPopinDataTypes, YFPopinImageTypes } from './types'
import { YfManagerModel } from '../../../types/yfPopin/yfManagerModel'
import { typeYfManagerEnum } from '../../../enums/yfManagerEnums'

const initialState: YfManagerModel = {
    popin_thumbnail: '',
    request_thumbnail: '',
    picture: '',
    data: {
        nom: '',
        horaires: '',
        contact: '',
        urgenceTech: undefined,
        ascensoriste: undefined,
        chauffagiste: undefined,
        parking: undefined,
        urgence: '',
        type: typeYfManagerEnum.manager
    }
}

const yfManager = (
    state: YfManagerModel = initialState,
    action: YFPopinImageTypes | YFPopinDataTypes
) => {
    switch (action.type) {
        case SAVE_YF_MANAGER_IMAGE: {
            return 'payload' in action ? {
                ...state,
                ...action.payload
            } : state
        }
        case SAVE_YF_MANAGER_DATA: {
            return 'payload' in action ? {
                ...state,
                data: {
                    ...state.data,
                    ...action.payload
                }
            } : state
        }
        default: {
            return state
        }
    }
}

export default yfManager
